module.exports = __webpack_public_path__ + "static/media/semiGrandExam.759711d0.png";